import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import Create from '../crud/create'
import menuItems from './menuItems'
import api from '../../api'
import omit from 'lodash/omit'
import fields from './fields'

class CopySession extends Component<any, any> {
  componentWillMount () {
    this.getResource()
  }

  constructor (props) {
    super(props)
    this.state = {
      resource: null
    }
  }

  getResource () {
    const path = `admin/sessions/${this.props.params.sessionId}?with_deleted=true`

    return api
      .get(path)
      .then(res => {
        if (res.status === 200) {
          res.json().then(resource => {
            this.setState({ resource: omit(resource, 'id') })
          })
        } else {
          browserHistory.push('/write-now/sessions')
        }
      })
  }

  render () {
    return (
      <Create
// @ts-ignore
        title={`Copying Session #${this.props.params.sessionId}`}
        fields={fields}
        apiPath={`admin/sessions/${this.props.params.sessionId}/copy`}
        successRedirectPath='/write-now/sessions'
        buildMenuItems={menuItems}
        resource={this.state.resource}
      />
    )
  }
}

export default CopySession
